import React, { useMemo } from 'react'
import clsx from 'clsx'
import { mutualTheme } from '~/utils/theme'
import { InputSubtitle } from '../InputSubtitle'
import { TextInput, TextInputProps } from '~/components'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

export type NameInputProps = {
  value?: string,
  label?: string,
  subtitle?: string,
  disabled?: boolean,
  className?: string,
  acceptCPF?: boolean,
  acceptCNPJ?: boolean,
  removeIcon?: boolean,
  placeholder?: string,
  errorMessage?: string,
  outsideLabel?: boolean,
  containerClassName?: string,
  endAdornment?: React.ReactNode,
  startAdornment?: React.ReactNode,
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void
}

const useStyles = makeStyles({
  label: {
    marginBottom: mutualTheme.spacing(0.5),
    color: mutualTheme.palette.textGray1.main
  },
  container: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  subTitle: {
    marginTop: mutualTheme.spacing(1)
  }
})

export const NameInput = React.forwardRef<HTMLDivElement, TextInputProps & NameInputProps>((props, ref) => {
  const {
    value, className, disabled, errorMessage,
    outsideLabel, containerClassName, subtitle,
    endAdornment, startAdornment, label, ...rest
  } = props
  const classes = useStyles()

  const formattedName = useMemo(() => {
    if (!value) return
    const formattedValue = value.replace(/[0-9]/g, '')
    return formattedValue
  }, [value])

  return (
    <Box className={clsx([classes.container, containerClassName])}>
      {outsideLabel && <Typography variant='body2' className={classes.label}>{props.label}</Typography>}
      <TextInput
        {...rest}
        ref={ref}
        label={!outsideLabel && label}
        variant='outlined'
        disabled={disabled}
        fullWidth
        value={formattedName}
        className={className}
        errorMessage={errorMessage}
        InputProps={{
          startAdornment,
          endAdornment
        }}
      />
      {subtitle && <InputSubtitle className={classes.subTitle} text={subtitle} />}
    </Box>
  )
})
